import { TabPanelBox } from './TabPanelBox';

export function TabPanel({
  children, value, index, ...other
}) {
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && (
        <TabPanelBox>
          {children}
        </TabPanelBox>
      )}
    </div>
  );
}
